import { ActionTypes } from "../type";

const initialState={
    state:null
}

export const stateReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.STATE:
            return {...state,state:action.payload}
        default:
            return state;
    }
}